import gql from 'graphql-tag'
import ProductListData from "../fragments/ProductListData"

export default gql`
query getProductById($id: String!) {
    product(getBy: ID, value: $id) {
        ...ProductListData
    }
}
${ProductListData}
`
